<script setup lang="ts">
import BaseIcon from '../../legacy/ui/base-icon/icon.vue';

type Props = {
  text: string;
  icon?: string;
  type?: 'main' | 'alt';
  size?: 'm' | 'l';
};
const { type = 'main', size = 'm' } = defineProps<Props>();
</script>

<template>
  <span :class="[$style.badge, $style[type], $style[size]]">
    <base-icon
      v-if="icon"
      :type="icon"
    />
    {{ text }}
  </span>
</template>

<style module>
.badge {
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  height: 36px;
  padding: 0 20px;
  display: inline-block;
  white-space: nowrap;
  border: 3px solid currentColor;
  border-radius: 100px;
}
.l {
  height: unset;
  padding: 11px 20px;
  line-height: 23px;
}
.main {
  color: #ff8a00;
}
.alt {
  color: $vantaBlackColor;
  display: inline-flex;
  align-items: center;
  border: 1px solid currentColor;
}
</style>

<i18n lang="json">{}</i18n>
